<template>
	<section class="main-box">
	<el-row>
		<el-col :span="3">
			<div class="treeBox">
				<el-input
						placeholder="输入关键字进行过滤"
						v-model="filterText">
				</el-input>
				<el-tree
						class="filter-tree"
						:data="data"
						:props="defaultProps"
						default-expand-all
						:filter-node-method="filterNode"
						show-checkbox
						ref="tree">
				</el-tree>
			</div>
		</el-col>
		<el-col :span="21">
			<el-tabs v-model="activeName"  class="modelview">
				<el-tab-pane label="用户管理" name="first">
					<el-upload
							class="upload-demo"
							action="https://jsonplaceholder.typicode.com/posts/"
							:on-preview="handleFilePreview"
							:on-remove="handleFileRemove"
							:before-remove="beforeFileRemove"
							:on-exceed="handleFileExceed"
							multiple
							:limit="3"
							:file-list="fileList">
						<el-button size="small" type="success">上传模型</el-button>
						<div slot="tip" class="el-upload__tip"></div>
					</el-upload>
					<div class="modelmap">
						<img src="../../assets/img/20190517121807.jpg">
					</div>
				</el-tab-pane>
				<el-tab-pane label="配置管理" name="second">
					<el-upload
							class="upload-demo"
							action="https://jsonplaceholder.typicode.com/posts/"
							:on-preview="handleFilePreview"
							:on-remove="handleFileRemove"
							:before-remove="beforeFileRemove"
							:on-exceed="handleFileExceed"
							multiple
							:limit="3"
							:file-list="fileList">
						<el-button size="small" type="success">上传模型</el-button>
						<div slot="tip" class="el-upload__tip"></div>
					</el-upload>
					<div class="modelmap">
						<img src="../../assets/img/20190517121807.jpg">
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-col>
	</el-row>
	</section>
</template>
<script>
	import { getUserListPage } from '../../api/api';

	export default {
		data() {
			return {
				fileList:[],
				activeName:'first',
				filterText: '',
				data: [
					{
					id: 1,
					label: '一级 1',
					children: [{
						id: 4,
						label: '二级 1-1',
						children: [{
							id: 9,
							label: '三级 1-1-1'
						}, {
							id: 10,
							label: '三级 1-1-2'
						}]
					}]
					},
					{
					id: 2,
					label: '一级 2',
					children: [{
						id: 5,
						label: '二级 2-1'
					}, {
						id: 6,
						label: '二级 2-2'
					}]
				}, {
					id: 3,
					label: '一级 3',
					children: [{
						id: 7,
						label: '二级 3-1'
					}, {
						id: 8,
						label: '二级 3-2'
					}]
				}],
				defaultProps: {
					children: 'children',
					label: 'label'
				}
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		methods: {
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			//上传文件需要的支持方法==================================
			handleFileRemove(file, fileList) {
				console.log(file, fileList);
			},
			handleFilePreview(file) {
				console.log(file);
			},
			handleFileExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeFileRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			}
			//=========================================================
		},
		mounted() {
			//初始化数据
		}
	};
</script>
<style>
	.treeBox{
		margin-top: 20px;
		padding: 10px;
		background: #f7f7f7;
		height:600px;
	}
	.filter-tree{margin-top: 10px;background:#f7f7f7 }
	.modelview{margin-top: 10px;margin-left: 10px;}
	.modelmap{margin-top: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/technology/model.vue